/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../../api/types.generated";
export type UpdateShiftSignupMutationVariables = Types.Exact<{
  checked_in: Types.Scalars["Boolean"];
  completed: Types.Scalars["Boolean"];
  shift_id: Types.Scalars["Int"];
  event_attendee_id: Types.Scalars["Int"];
}>;

export type UpdateShiftSignupMutation = {
  updateShiftSignup: Pick<Types.Success, "status">;
};

export const UpdateShiftSignupDocument = gql`
  mutation UpdateShiftSignup(
    $checked_in: Boolean!
    $completed: Boolean!
    $shift_id: Int!
    $event_attendee_id: Int!
  ) {
    updateShiftSignup(
      data: { checked_in: $checked_in, completed: $completed }
      where: {
        AND: [
          { shift_id: { equals: $shift_id } }
          { event_attendee_id: { equals: $event_attendee_id } }
        ]
      }
    ) {
      status
    }
  }
`;

/**
 * __useUpdateShiftSignupMutation__
 *
 * To run a mutation, you first call `useUpdateShiftSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShiftSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShiftSignupMutation, { data, loading, error }] = useUpdateShiftSignupMutation({
 *   variables: {
 *      checked_in: // value for 'checked_in'
 *      completed: // value for 'completed'
 *      shift_id: // value for 'shift_id'
 *      event_attendee_id: // value for 'event_attendee_id'
 *   },
 * });
 */
export function useUpdateShiftSignupMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateShiftSignupMutation,
    UpdateShiftSignupMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateShiftSignupMutation,
    UpdateShiftSignupMutationVariables
  >(UpdateShiftSignupDocument, baseOptions);
}
export type UpdateShiftSignupMutationHookResult = ReturnType<
  typeof useUpdateShiftSignupMutation
>;
export type UpdateShiftSignupMutationResult =
  ApolloReactCommon.MutationResult<UpdateShiftSignupMutation>;
export type UpdateShiftSignupMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateShiftSignupMutation,
    UpdateShiftSignupMutationVariables
  >;
